import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { ITyped } from '../shared/interfaces/typed.interface';
import { ChartTypesEnum } from './chart-types.enum';
import { Dataset } from './sub-models/dataset.model';

export const BAR_CHART_SCHEMA = Object.freeze({
  TYPE: '',
  LABELS: List<string>([]),
  HIGHLIGHT: null, // number
  BASELINE: 0,
  DATASETS: List<Dataset>([]),
  GROUP: 0,
});
const RECORD = generateSchema(BAR_CHART_SCHEMA);
const KEYS: any = generateKeys(BAR_CHART_SCHEMA);

export class BarChart extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.DATASETS,
        value: props.get(KEYS.DATASETS)
          ? this.datasets.map((params) => new Dataset(params))
          : List<Dataset>([]),
      },
    ]);

    return selfModel as BarChart;
  }

  get type(): string {
    return ChartTypesEnum.bar_chart;
  }

  get labels(): List<string> {
    return this.get(KEYS.LABELS);
  }

  get highlight(): number {
    return this.get(KEYS.HIGHLIGHT);
  }

  get baseline(): number {
    return this.get(KEYS.BASELINE);
  }

  get datasets(): List<Dataset> {
    return this.get(KEYS.DATASETS);
  }

  get group(): number {
    return this.get(KEYS.GROUP);
  }
}
